import React, { useContext } from 'react';

import { media } from 'context';
import { EmailInput, Layout, PhoneInput, TextInput } from 'ds';
import { actions } from 'store/ServicesRequest';
import { selectServicesRequestUser } from 'store/ServicesRequest/selectors';
import { useAppDispatch, useAppSelector } from 'store/hooks';

interface Props {}

const UserFields: React.FC<Props> = () => {
  const user = useAppSelector(selectServicesRequestUser);
  const dispatch = useAppDispatch();
  const { xs, sm } = useContext(media);
  const isMobile = xs || sm;

  return (
    <Layout direction="column" align="center" gap={16}>
      <Layout {...(isMobile ? { width: '100%' } : { gap: 16, width: '100%' })}>
        <Layout {...(isMobile ? { width: '100%' } : { equalWidth: true })}>
          <TextInput
            data-cy="first-name-input"
            placeholder="First name"
            value={user?.firstname || ''}
            onChange={({ value }) => dispatch(actions.setUser({ ...user, firstname: value }))}
            autoFocus
            size="sm"
            label="First name"
            required
          />
        </Layout>
        <Layout {...(isMobile ? { width: '100%', marginTop: 16 } : { equalWidth: true })}>
          <TextInput
            data-cy="last-name-input"
            placeholder="Last name"
            value={user?.lastname || ''}
            onChange={({ value }) => dispatch(actions.setUser({ ...user, lastname: value }))}
            size="sm"
            label="Last name"
            required
          />
        </Layout>
      </Layout>
      <Layout width="100%">
        <EmailInput
          data-cy="email-input"
          placeholder="Email"
          size="sm"
          value={user?.email || ''}
          onChange={({ value }) => dispatch(actions.setUser({ ...user, email: value }))}
          required
        />
      </Layout>
      <Layout width="100%">
        <PhoneInput
          data-cy="phone-input"
          value={user?.phone || ''}
          callingCode={user?.callingCode || ''}
          onCallingCodeChange={value => dispatch(actions.setUser({ ...user, callingCode: value }))}
          onChange={({ value }) => dispatch(actions.setUser({ ...user, phone: value }))}
          size="sm"
          required
        />
      </Layout>
      <Layout width="100%">
        <TextInput
          data-cy="job-title-input"
          placeholder="Job title"
          value={user?.jobTitle || ''}
          onChange={({ value }) => dispatch(actions.setUser({ ...user, jobTitle: value }))}
          size="sm"
          label="Job title"
        />
      </Layout>
    </Layout>
  );
};

export default UserFields;
